import { render, staticRenderFns } from "./CorreoCortas.vue?vue&type=template&id=11c3f918&"
import script from "./CorreoCortas.vue?vue&type=script&lang=js&"
export * from "./CorreoCortas.vue?vue&type=script&lang=js&"
import style0 from "./CorreoCortas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports